export default __webpack_public_path__ + "static/media/E05.1e8219ac.png";